// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"3a7fe3ba","453":"224cb58d","485":"6bdbdf31"}[chunkId] + ".chunk.js";
};